import Vue from 'vue';
import Vuex from 'vuex';
import vuexI18n from 'vuex-i18n';
import Locales from './vue-i18n-locales.generated';

Vue.use(Vuex);
const store = new Vuex.Store();

Vue.use(vuexI18n.plugin, store);

Vue.i18n.add('en', Locales.en);
Vue.i18n.add('de', Locales.de);


// set fallback for non-translated strings
Vue.i18n.fallback('de');

// set the start locale to use
switch (document.documentElement.lang) {
    case 'en':
    case 'de':
        Vue.i18n.set(document.documentElement.lang);
        break;
    default:
        Vue.i18n.set('de');
}